import { useEffect, useState } from 'react'
import { Box } from '@mui/system'
import { useMediaQuery, Typography } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import LoginBackSvg from '../../images/loginBackSvg.svg'
import LoginRightImage from '../../images/loginRightImage.svg'
import OfoqTextField from '../../components/Forms/OfoqTextField.jsx'
import OfoqPasswordField from '../../components/Forms/OfoqPasswordField.jsx'
import OfoqThemeBtn from '../../components/Buttons/OfoqThemeBtn.jsx'
import { userAuthLogin, userAuthResetAlertHandler } from '../../redux/features/userAuth/userAuthThunk'
import { selectAuthUser } from '../../redux/features/userAuth/userAuthSlice'
import { isNotEmpty } from '../../utils/helpers'
import AppRoutes from '../../services/AppRoutes'
import CookiesStorageService from '../../services/CookiesStorageService'
import ResponsiveAppBar from '../../components/ResponsiveAppBar'
import LinkBtn from '../../components/Buttons/LinkBtn.jsx'
import SwitchLanguageButton from '../../components/Buttons/SwitchLanguageButton.jsx'
import UseTranslation from '../../hooks/UseTranslation.jsx'
import LoaderWithErrorHandler from '../../components/PageHelpers/LoaderWithErrorHandler.jsx'

const Index = () => {
  const isXsScreen = useMediaQuery((theme) => theme.breakpoints.only('xs'))
  const dispatch = useDispatch()
  const history = useHistory()
  const userAuth = useSelector(selectAuthUser)
  const { t } = UseTranslation()
  const [email, setEmail] = useState(null)
  const [password, setPassword] = useState(null)

  useEffect(() => {
    if (isNotEmpty(CookiesStorageService.getAccessToken())) {
      const isFirstLogin = CookiesStorageService.getIsFirstLogin()
      if (isFirstLogin) {
        history.push(AppRoutes.firstTimePassword)
      } else {
        history.push(AppRoutes.landing)
      }
    }
  }, [userAuth])

  const submitHandler = async (e) => {
    e.preventDefault()
    dispatch(
      userAuthLogin({
        queries: {
          email,
          password,
        },
      }),
    )
  }

  return (
    <Box sx={styles.root}>
       {isXsScreen && <ResponsiveAppBar onlyLogo /> }
      <Box sx={styles.loginContainer}>
        <Box sx={styles.leftSideContainer}>
          <Box sx={styles.titleContainer}>
          <Typography variant={'h4'} sx={styles.formTitle}>
           {`${t?.['Login to']} Orgarise`}
            </Typography>
             {!isXsScreen && <SwitchLanguageButton login /> }
          </Box>

          <form onSubmit={submitHandler} style={styles.formContainer}>
            <OfoqTextField customStyle={styles.textField}
              defaultValue={email}
              refState={setEmail}
              name={t?.['Email Address']}
              customPlaceHolder={t?.['Type Your Email Address']}
            />
            <OfoqPasswordField
              defaultValue={password}
              refState={setPassword}
              placeholder={t?.['type your password']}
              name={t?.Password}
              hideInputValidator
            />

            <Box sx={styles.formBtns}>
              <LinkBtn customStyle={styles.forgotPassword} to={AppRoutes.forgotPassword} name={t?.['Forgot Your Password?']} />
              <OfoqThemeBtn customStyle={styles.continueBtn} name={t?.Continue} type='submit' onClick={(e) => submitHandler(e)} />
            </Box>
          </form>
        </Box>

          <Box sx={styles.rightImage}>
            <img src={LoginRightImage} alt='login img' />
          </Box>
          <Box sx={styles.backSvg}>
            <img src={LoginBackSvg} alt='login img' />
          </Box>
        </Box>

  <LoaderWithErrorHandler store={userAuth}
        resetAlertHandler={userAuthResetAlertHandler} />
    </Box>
  )
}

const styles = {
  root: {
    '& header': {
      marginBottom: '0px',
    },
  },
  loginContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    flexDirection: { xs: 'column-reverse', sm: 'row' },
    position: 'relative',
    minHeight: { xs: '70vh', sm: '90vh' },
    my: 'auto',
  },

  leftSideContainer: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    maxWidth: { xs: '100%', sm: '400px', md: '500px' },
    width: '100%',
    marginTop: { xs: '20px', sm: '0px' },
    mx: { xs: '0px', sm: '40px' },
    px: '10px',
    zIndex: '2',
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },

  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: { xs: '100%', sm: '400px' },
  },

  textField: {
    marginBottom: { xs: '10px', sm: '40px' },
    formInputLabelRequired: {
      fontSize: { xs: '10px', md: 'unset' },
    },
  },
  formTitle: {
    color: 'primary.contrastText',
    marginBottom: { xs: '30px', sm: '40px' },
    fontSize: { xs: '24px', sm: '28px' },
    textAlign: { xs: 'unset', md: 'left' },
    fontWeight: 500,
  },

  formBtns: {
    display: 'flex',
    minWidth: '100%',
    flexDirection: { xs: 'column-reverse', sm: 'row' },
    justifyContent: { xs: 'center', sm: 'space-between' },
    alignItems: 'center',
    marginTop: { xs: '10px', sm: '30px' },
  },
  forgotPassword: {
    textDecoration: 'unset',
    minWidth: 'max-content',
    display: 'flex',
    alignItems: { xs: 'center', sm: 'left' },
    justifyContent: { xs: 'center', sm: 'left' },
    color: '#98a9bc',
    backgroundColor: 'transparent !important',
    '&:hover': {
      color: '#98a9bc',
    },
  },
  continueBtn: {
    maxWidth: { xs: '100%', sm: '180px' },
    height: { xs: '40px', sm: '40px' },
  },

  backSvg: {
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 0,
    minHeight: '100vh',
    width: '100%',
  },
  rightImage: {
    position: 'relative',
    zIndex: '8',
    '& img': {
      width: { xs: '100%', sm: '300px', md: '400px', lg: '500px' },
      height: { xs: '200px', sm: '100%', md: '400px', lg: '500px' },
      mt: '20px',
    },
  },
  errorContainer: {
    width: '100%',
    marginBottom: '30px',
  },
}

export default Index
